import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiEdit, FiTrash2, FiSearch, FiCalendar, FiPlus, FiX } from 'react-icons/fi';
import { database } from '../../Firebase';
import { ref, push, onValue, remove, update } from 'firebase/database';

const DeadstockDisposal = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { grampanchayatName, arthikVarshLabel } = location.state || {};

    const [viewMode, setViewMode] = useState('list'); // 'list' or 'form'
    const [searchTerm, setSearchTerm] = useState('');
    const [disposals, setDisposals] = useState([]);
    
    // Data Sources
    const [persons, setPersons] = useState([]);
    const [deadstockItems, setDeadstockItems] = useState([]);
    const [ledgers, setLedgers] = useState([]);

    // Form State
    const initialFormState = {
        disposalNo: '1', // Auto-increment ideally
        transactionType: 'Cash', // Cash or Transfer
        voucherNo: '',
        disposalDate: new Date().toISOString().split('T')[0],
        personId: '',
        personName: '',
        
        // Item Entry
        currentItem: {
            itemId: '',
            itemName: '',
            measurement: '',
            currentStock: 0,
            quantity: '',
            isTaxInclusive: false,
            rate: '',
            taxAmount: 0,
            totalAmount: 0
        },
        items: [],
        
        // Transaction Details
        receiptNo: '',
        ledgerId: '',
        ledgerName: '',
        accountId: '', // Bank/Cash Account
        accountName: '',
        remarks: ''
    };
    const [formData, setFormData] = useState(initialFormState);

    // Fetch Data
    useEffect(() => {
        // Disposals
        const disposalRef = ref(database, 'Grampanchayat/Panipuravtha/DeadstockDisposal');
        onValue(disposalRef, (snapshot) => {
            const data = snapshot.val();
            const loaded = [];
            if (data) Object.keys(data).forEach(key => loaded.push({ id: key, ...data[key] }));
            setDisposals(loaded);
        });

        // Persons
        const personsRef = ref(database, 'Grampanchayat/Panipuravtha/Persons');
        onValue(personsRef, (snapshot) => {
            const data = snapshot.val();
            const loaded = [];
            if (data) Object.keys(data).forEach(key => loaded.push({ id: key, ...data[key] }));
            setPersons(loaded);
        });

        // Deadstock Items
        const stockRef = ref(database, 'Grampanchayat/Panipuravtha/Deadstock');
        onValue(stockRef, (snapshot) => {
            const data = snapshot.val();
            const loaded = [];
            if (data) Object.keys(data).forEach(key => loaded.push({ id: key, ...data[key] }));
            setDeadstockItems(loaded);
        });

        // Ledgers (Mock for now, or fetch from Ledger node if exists)
        setLedgers([
            { id: 'l1', name: 'General Fund', group: 'Assets' },
            { id: 'l2', name: 'Deadstock Sales', group: 'Income' }
        ]);

    }, []);

    // Modals Check
    const [isPersonModalOpen, setIsPersonModalOpen] = useState(false);
    const [isItemModalOpen, setIsItemModalOpen] = useState(false);
    const [isLedgerModalOpen, setIsLedgerModalOpen] = useState(false);
    const [modalSearch, setModalSearch] = useState('');

    const handleAddItem = () => {
        const { itemId, quantity, rate } = formData.currentItem;
        if (!itemId || !quantity || !rate) {
            alert('कृपया वस्तू, संख्या आणि दर भरा');
            return;
        }

        const qty = parseFloat(quantity);
        const rt = parseFloat(rate);
        const amount = qty * rt; // Simplified calc

        const newItem = {
            ...formData.currentItem,
            amount: amount,
            tax: 0, // Placeholder
            finalAmount: amount
        };

        setFormData(prev => ({
            ...prev,
            items: [...prev.items, newItem],
            currentItem: initialFormState.currentItem
        }));
    };

    const handleRemoveItem = (index) => {
        setFormData(prev => ({
            ...prev,
            items: prev.items.filter((_, i) => i !== index)
        }));
    };

    const handleSave = () => {
         if (!formData.personId || formData.items.length === 0) {
            alert('कृपया व्यक्ती आणि वस्तू निवडा');
            return;
        }
        
        const disposalRef = ref(database, 'Grampanchayat/Panipuravtha/DeadstockDisposal');
        push(disposalRef, formData)
            .then(() => {
                alert('विल्हेवाट यशस्वीरित्या साठवली');
                setFormData(initialFormState);
                setViewMode('list');
            })
            .catch(err => alert(err.message));
    };

    // Calculate Totals
    const totalAmount = formData.items.reduce((sum, item) => sum + (parseFloat(item.finalAmount) || 0), 0);

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-6 font-poppins">
            
            {/* --- MODALS --- */}
            
            {/* Person Modal */}
            {isPersonModalOpen && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl overflow-hidden animate-fade-in-up">
                        <div className="bg-[#267c77] text-white p-3 flex justify-between items-center">
                            <h3 className="font-bold text-lg">व्यक्ती निवड</h3>
                            <button onClick={() => setIsPersonModalOpen(false)}><FiX size={24} /></button>
                        </div>
                        <div className="p-4">
                            <input type="text" placeholder="Search..." className="w-full border p-2 rounded mb-4" onChange={e => setModalSearch(e.target.value)} />
                            <div className="max-h-80 overflow-y-auto">
                                <table className="w-full text-sm text-left border-collapse border">
                                    <thead className="bg-[#267c77]/10">
                                        <tr><th className="p-2 border">Name</th><th className="p-2 border">Mobile</th></tr>
                                    </thead>
                                    <tbody>
                                        {persons.filter(p => (p.firstName + p.surname).toLowerCase().includes(modalSearch.toLowerCase())).map(p => (
                                            <tr key={p.id} onClick={() => {
                                                setFormData(prev => ({...prev, personId: p.id, personName: `${p.firstName} ${p.surname}`}));
                                                setIsPersonModalOpen(false);
                                            }} className="cursor-pointer hover:bg-gray-100">
                                                <td className="p-2 border">{p.firstName} {p.fatherName} {p.surname}</td>
                                                <td className="p-2 border">{p.mobileNo}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Item Modal */}
             {isItemModalOpen && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl overflow-hidden animate-fade-in-up">
                        <div className="bg-[#267c77] text-white p-3 flex justify-between items-center">
                            <h3 className="font-bold text-lg">डेडस्टॉक वस्तू निवड</h3>
                            <button onClick={() => setIsItemModalOpen(false)}><FiX size={24} /></button>
                        </div>
                         <div className="p-4">
                            <input type="text" placeholder="Search..." className="w-full border p-2 rounded mb-4" onChange={e => setModalSearch(e.target.value)} />
                            <div className="max-h-80 overflow-y-auto">
                                <table className="w-full text-sm text-left border-collapse border">
                                    <thead className="bg-[#267c77]/10">
                                        <tr><th className="p-2 border">Item Name</th><th className="p-2 border">Current Stock</th></tr>
                                    </thead>
                                    <tbody>
                                        {deadstockItems.filter(i => i.name.toLowerCase().includes(modalSearch.toLowerCase())).map(item => (
                                            <tr key={item.id} onClick={() => {
                                                setFormData(prev => ({
                                                    ...prev, 
                                                    currentItem: {
                                                        ...prev.currentItem,
                                                        itemId: item.id,
                                                        itemName: item.name,
                                                        measurement: item.measurementType || '',
                                                        currentStock: 100 // Mock
                                                    }
                                                }));
                                                setIsItemModalOpen(false);
                                            }} className="cursor-pointer hover:bg-gray-100">
                                                <td className="p-2 border">{item.name}</td>
                                                <td className="p-2 border text-green-600 font-bold">100</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

             {/* Ledger Modal */}
             {isLedgerModalOpen && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl overflow-hidden animate-fade-in-up">
                        <div className="bg-[#267c77] text-white p-3 flex justify-between items-center">
                            <h3 className="font-bold text-lg">खातावणी निवड</h3>
                            <button onClick={() => setIsLedgerModalOpen(false)}><FiX size={24} /></button>
                        </div>
                         <div className="p-4">
                            <div className="max-h-80 overflow-y-auto">
                                <table className="w-full text-sm text-left border-collapse border">
                                    <thead className="bg-[#267c77]/10">
                                        <tr><th className="p-2 border">Name</th><th className="p-2 border">Group</th></tr>
                                    </thead>
                                    <tbody>
                                        {ledgers.map(l => (
                                            <tr key={l.id} onClick={() => {
                                                setFormData(prev => ({...prev, ledgerId: l.id, ledgerName: l.name}));
                                                setIsLedgerModalOpen(false);
                                            }} className="cursor-pointer hover:bg-gray-100">
                                                <td className="p-2 border">{l.name}</td>
                                                <td className="p-2 border">{l.group}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-lg border border-[#267c77] overflow-hidden">
                {/* Header */}
                <div className="bg-[#267c77] text-white p-4 flex justify-between items-center">
                    <div className="flex items-center gap-2">
                        <button onClick={() => viewMode === 'form' ? setViewMode('list') : navigate(-1)} className="bg-white/10 hover:bg-white/20 p-2 rounded-full mr-2"><FiArrowLeft /></button>
                        <h1 className="text-xl font-bold">{viewMode === 'list' ? 'डेडस्टॉक विल्हेवाट माहिती' : 'डेडस्टॉक विल्हेवाट व्यवहार माहिती'}</h1>
                    </div>
                    {viewMode === 'list' && (
                        <button onClick={() => {setFormData(initialFormState); setViewMode('form');}} className="bg-[#1e6b66] px-6 py-1.5 rounded font-bold text-sm">नवीन</button>
                    )}
                </div>

                {viewMode === 'list' ? (
                    <div className="p-4">
                         <div className="flex gap-4 items-center bg-gray-50 p-3 rounded border border-gray-200 mb-4">
                            <label className="font-medium text-gray-700">व्यवहार दिनांक:</label>
                            <input type="date" className="p-1 border rounded" />
                            <button className="bg-[#267c77] text-white px-4 py-1 rounded text-sm font-bold">दाखवा</button>
                         </div>
                         <div className="flex gap-2 mb-4">
                            <input type="text" placeholder="शोधणे" className="flex-grow border p-2 rounded" />
                            <button className="bg-[#267c77] text-white px-6 py-2 rounded font-bold">शोधणे</button>
                         </div>
                         <table className="w-full text-sm text-center border-collapse">
                            <thead className="bg-[#267c77] text-white">
                                <tr>
                                    <th className="px-4 py-3 border-r">व्यवहार दिनांक</th>
                                    <th className="px-4 py-3 border-r text-left">व्यक्तीचे नाव</th>
                                    <th className="px-4 py-3 border-r">स्लिप क्र.</th>
                                    <th className="px-4 py-3 border-r">एकूण रक्कम</th>
                                    <th className="px-4 py-3">पर्याय</th>
                                </tr>
                            </thead>
                            <tbody>
                                {disposals.length === 0 ? <tr><td colSpan="5" className="p-4">No records found</td></tr> : disposals.map(d => (
                                    <tr key={d.id} className="border-b">
                                        <td className="p-2 border-r">{d.disposalDate}</td>
                                        <td className="p-2 border-r text-left">{d.personName}</td>
                                        <td className="p-2 border-r">{d.voucherNo}</td>
                                        <td className="p-2 border-r">{d.items.reduce((s,i) => s + i.finalAmount, 0)}</td>
                                        <td className="p-2"><button className="text-[#267c77] font-bold">बदल</button></td>
                                    </tr>
                                ))}
                            </tbody>
                         </table>
                    </div>
                ) : (
                    <div className="p-4 bg-gray-50 text-sm">
                        {/* Top Form */}
                        <div className="bg-white p-4 border border-[#267c77]/30 rounded mb-4">
                            <div className="grid grid-cols-1 md:grid-cols-5 gap-4 items-center mb-4">
                                <div className="flex items-center gap-2">
                                    <label>विल्हेवाट क्र.:</label>
                                    <input type="text" value={formData.disposalNo} disabled className="w-20 bg-gray-100 border p-1 rounded" />
                                </div>
                                <div className="flex items-center gap-4 col-span-2">
                                    <label>व्यवहार प्रकार:</label>
                                    <label className="flex items-center gap-1"><input type="radio" checked={formData.transactionType === 'Cash'} onChange={() => setFormData({...formData, transactionType: 'Cash'})} /> रोख</label>
                                    <label className="flex items-center gap-1"><input type="radio" checked={formData.transactionType === 'Transfer'} onChange={() => setFormData({...formData, transactionType: 'Transfer'})} /> वर्ग / ट्रान्सफर</label>
                                </div>
                                <div className="flex items-center gap-2">
                                    <label>व्हाउचर नं.:</label>
                                    <input type="text" value={formData.voucherNo} onChange={e => setFormData({...formData, voucherNo: e.target.value})} className="border p-1 rounded w-full" />
                                </div>
                                <div className="flex items-center gap-2">
                                    <label>विल्हेवाट दिनांक:</label>
                                    <input type="date" value={formData.disposalDate} onChange={e => setFormData({...formData, disposalDate: e.target.value})} className="border p-1 rounded w-full" />
                                </div>
                            </div>
                            <div className="flex items-center gap-2">
                                <label className="w-24">व्यक्तीचे नाव:</label>
                                <div className="flex-grow flex">
                                    <input type="text" value={formData.personName} readOnly className="w-full border p-1 rounded-l" placeholder="Select Person" />
                                    <button onClick={() => setIsPersonModalOpen(true)} className="bg-[#267c77] text-white px-3 rounded-r">...</button>
                                </div>
                            </div>
                        </div>

                        {/* Items Section */}
                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
                            {/* Item Entry Form */}
                            <div className="lg:col-span-4 border border-[#267c77] rounded bg-white p-4">
                                <h3 className="bg-[#267c77] text-white text-center p-1 mb-4 rounded-t -mt-4 -mx-4">वस्तुची माहिती</h3>
                                <div className="space-y-3">
                                    <div>
                                        <label className="block mb-1">वस्तुचे नाव:</label>
                                        <div className="flex">
                                            <input type="text" value={formData.currentItem.itemName} readOnly className="w-full border p-1 rounded-l" />
                                            <button onClick={() => setIsItemModalOpen(true)} className="bg-[#267c77] text-white px-3 rounded-r">...</button>
                                        </div>
                                    </div>
                                    <div><label>मोजमाप प्रकार:</label><input type="text" value={formData.currentItem.measurement} readOnly className="w-full border p-1 rounded bg-gray-50" /></div>
                                    <div><label>शिल्लक संख्या:</label><div className="bg-[#267c77] text-white p-1 text-center rounded">{formData.currentItem.currentStock}</div></div>
                                    <div>
                                        <label>संख्या:</label>
                                        <input type="number" value={formData.currentItem.quantity} onChange={e => setFormData({...formData, currentItem: {...formData.currentItem, quantity: e.target.value}})} className="w-full border p-1 rounded" placeholder="संख्या भरा" />
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <label>करा सहित:</label>
                                        <input type="checkbox" checked={formData.currentItem.isTaxInclusive} onChange={e => setFormData({...formData, currentItem: {...formData.currentItem, isTaxInclusive: e.target.checked}})} />
                                    </div>
                                    <div>
                                        <label>दर:</label>
                                        <input type="number" value={formData.currentItem.rate} onChange={e => setFormData({...formData, currentItem: {...formData.currentItem, rate: e.target.value}})} className="w-full border p-1 rounded" placeholder="दर भरा" />
                                    </div>
                                    <div>
                                        <label>रक्कम:</label>
                                        <input type="text" value={formData.currentItem.quantity * formData.currentItem.rate || 0} readOnly className="w-full border p-1 rounded bg-gray-100" />
                                    </div>
                                    <button onClick={handleAddItem} className="w-full bg-[#267c77] text-white p-2 rounded font-bold mt-2">यादित भरा</button>
                                </div>
                            </div>

                            {/* Items Table */}
                            <div className="lg:col-span-8 border border-[#267c77] rounded bg-white flex flex-col">
                                <thead className="bg-[#267c77] text-white grid grid-cols-12 text-center p-2 text-xs font-bold">
                                    <div className="col-span-1">#</div>
                                    <div className="col-span-4 text-left">वस्तुचे नाव</div>
                                    <div className="col-span-2">मोजमाप</div>
                                    <div className="col-span-1">संख्या</div>
                                    <div className="col-span-1">दर</div>
                                    <div className="col-span-1">एकूण</div>
                                    <div className="col-span-1 text-center">#</div>
                                </thead>
                                <div className="flex-grow bg-gray-100 p-2 overflow-y-auto h-64">
                                    {formData.items.map((item, idx) => (
                                        <div key={idx} className="grid grid-cols-12 text-center border-b border-gray-300 p-2 bg-white text-xs">
                                            <div className="col-span-1">{idx+1}</div>
                                            <div className="col-span-4 text-left">{item.itemName}</div>
                                            <div className="col-span-2">{item.measurement}</div>
                                            <div className="col-span-1">{item.quantity}</div>
                                            <div className="col-span-1">{item.rate}</div>
                                            <div className="col-span-1">{item.finalAmount}</div>
                                            <div className="col-span-1 text-red-500 cursor-pointer" onClick={() => handleRemoveItem(idx)}><FiTrash2 /></div>
                                        </div>
                                    ))}
                                    {formData.items.length === 0 && <div className="text-center p-4 text-gray-500">No records found</div>}
                                </div>
                                <div className="bg-gray-200 p-2 flex justify-between font-bold text-xs">
                                     <span>एकूण</span>
                                     <span>{totalAmount.toFixed(2)}</span>
                                </div>
                            </div>
                        </div>

                        {/* Transaction Details */}
                         <div className="mt-4 border border-[#267c77] rounded bg-white">
                            <h3 className="bg-[#267c77] text-white p-2 text-sm font-bold rounded-t">व्यवहार तपशील</h3>
                            <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div className="grid grid-cols-3 gap-2 items-center">
                                    <label>पावती नं.:</label>
                                    <input type="text" value={formData.receiptNo} onChange={e => setFormData({...formData, receiptNo: e.target.value})} className="col-span-2 border p-1 rounded" />
                                </div>
                                <div className="grid grid-cols-3 gap-2 items-center">
                                    <label>दिनांक:</label>
                                    <input type="date" value={formData.disposalDate} readOnly className="col-span-2 border p-1 rounded bg-gray-100" />
                                </div>
                                <div className="grid grid-cols-3 gap-2 items-center">
                                    <label>व्यक्तीचे नाव:</label>
                                    <input type="text" value={formData.personName} readOnly className="col-span-2 border p-1 rounded bg-gray-100" />
                                </div>
                                <div className="grid grid-cols-3 gap-2 items-center">
                                    <label>खातावणी:</label>
                                    <div className="col-span-2 flex">
                                        <input type="text" value={formData.ledgerName} readOnly className="w-full border p-1 rounded-l" />
                                        <button onClick={() => setIsLedgerModalOpen(true)} className="bg-[#267c77] text-white px-2 rounded-r">...</button>
                                    </div>
                                </div>
                                <div className="grid grid-cols-3 gap-2 items-center">
                                    <label>खाते:</label>
                                    <div className="col-span-2 flex">
                                         {/* Assuming same logic for Account as Ledger for now, or just a text field */}
                                        <input type="text" value={formData.accountName} readOnly className="w-full border p-1 rounded-l" placeholder="Select Account" />
                                        <button className="bg-[#267c77] text-white px-2 rounded-r">...</button>
                                    </div>
                                </div>
                                 <div className="grid grid-cols-3 gap-2 items-center">
                                    <label>व्यवहार रक्कम:</label>
                                    <input type="text" value={totalAmount} readOnly className="col-span-2 border p-1 rounded bg-gray-100" />
                                </div>
                            </div>
                         </div>
                         
                         <div className="flex justify-center gap-4 mt-6">
                             <button onClick={handleSave} className="bg-[#267c77] text-white px-8 py-2 rounded font-bold">साठविणे</button>
                             <button onClick={() => setViewMode('list')} className="bg-red-600 text-white px-8 py-2 rounded font-bold">रद्द करणे</button>
                         </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DeadstockDisposal;
